const THEME_PRESETS = [
  {
    key: 'graphite',
    color: '#282F44',
    aliases: ['#9400D3'],
    primary: '#282F44',
    sideBar: '#22293D',
    titleBg1: '#3A455F',
    titleBg2: '#4A5878',
    chartColor: '#F7FAFF',
    chartBg: '#70809D',
    titleText: '#F8FAFC',
    textColorD: '#111827',
    btnToggle: '#5D7BDA',
    themeDarkerColor: '#1B2234',
    themeSoftColor: '#EEF2F8',
  },
  {
    key: 'ocean',
    color: '#1E5566',
    aliases: ['#192A56', '#1B76FF', '#55AFBA'],
    primary: '#1E5566',
    sideBar: '#174654',
    titleBg1: '#2D6C7E',
    titleBg2: '#3D8194',
    chartColor: '#F2FBFC',
    chartBg: '#75959E',
    titleText: '#F3FBFC',
    textColorD: '#10242B',
    btnToggle: '#5BA7B8',
    themeDarkerColor: '#143844',
    themeSoftColor: '#EDF7F9',
  },
  {
    key: 'forest',
    color: '#1B4F3E',
    aliases: ['#91AA23'],
    primary: '#1B4F3E',
    sideBar: '#163F31',
    titleBg1: '#2B6655',
    titleBg2: '#3A7B68',
    chartColor: '#F2FAF6',
    chartBg: '#6F9187',
    titleText: '#F3FAF7',
    textColorD: '#10231C',
    btnToggle: '#5A9E82',
    themeDarkerColor: '#12372B',
    themeSoftColor: '#EDF5F1',
  },
  {
    key: 'ember',
    color: '#5B4036',
    aliases: ['#D04242', '#FFA012'],
    primary: '#5B4036',
    sideBar: '#4A342C',
    titleBg1: '#755042',
    titleBg2: '#8A6454',
    chartColor: '#FDF8F4',
    chartBg: '#A18A7E',
    titleText: '#FFF8F3',
    textColorD: '#291C15',
    btnToggle: '#B88260',
    themeDarkerColor: '#38271F',
    themeSoftColor: '#F7EEE8',
  },
]

const DEFAULT_THEME_PRESET = THEME_PRESETS[0]
const DEFAULT_THEME_COLOR = DEFAULT_THEME_PRESET.color

function normalizeHexColor(value) {
  return typeof value === 'string' ? value.trim().toUpperCase() : ''
}

function hexToRgbString(hexColor) {
  const normalized = normalizeHexColor(hexColor).replace('#', '')
  if (!/^[0-9A-F]{6}$/.test(normalized)) {
    return '40,47,68'
  }

  const value = parseInt(normalized, 16)
  const r = (value >> 16) & 255
  const g = (value >> 8) & 255
  const b = value & 255
  return `${r}, ${g}, ${b}`
}

function getThemePreset(themeColor) {
  const normalized = normalizeHexColor(themeColor)
  if (!normalized) {
    return DEFAULT_THEME_PRESET
  }

  return (
    THEME_PRESETS.find((preset) => {
      if (normalizeHexColor(preset.color) === normalized) {
        return true
      }
      return (preset.aliases || []).some((alias) => normalizeHexColor(alias) === normalized)
    }) || DEFAULT_THEME_PRESET
  )
}

function normalizeThemeColor(themeColor) {
  return getThemePreset(themeColor).color
}

function applyCssThemeVars(preset) {
  if (typeof document === 'undefined') {
    return
  }

  const rootStyle = document.documentElement.style
  rootStyle.setProperty('--theme-color', preset.primary)
  rootStyle.setProperty('--theme-darker-color', preset.themeDarkerColor)
  rootStyle.setProperty('--theme-soft-color', preset.themeSoftColor)
  rootStyle.setProperty('--theme-title-text', preset.titleText)
  rootStyle.setProperty('--theme-accent-color', preset.btnToggle)
  rootStyle.setProperty('--theme-surface-bg', preset.themeSoftColor)
  rootStyle.setProperty('--theme-text-primary', preset.textColorD)
  rootStyle.setProperty('--theme-text-secondary', preset.chartBg)
  rootStyle.setProperty('--v-theme-primary-rgb', hexToRgbString(preset.primary))
  rootStyle.setProperty('--theme-accent-rgb', hexToRgbString(preset.btnToggle))
  rootStyle.setProperty('--theme-surface-rgb', hexToRgbString(preset.themeSoftColor))
}

function applyThemePreset(vuetify, themeColor) {
  const preset = getThemePreset(themeColor)
  const themeValues = {
    primary: preset.primary,
    sideBar: preset.sideBar,
    titleBg1: preset.titleBg1,
    titleBg2: preset.titleBg2,
    chartColor: preset.chartColor,
    chartBg: preset.chartBg,
    titleText: preset.titleText,
    textColorD: preset.textColorD,
    btnToggle: preset.btnToggle,
  }

  const themeTargets = [
    vuetify?.theme?.themes?.light,
    vuetify?.framework?.theme?.themes?.light,
    vuetify?.userPreset?.theme?.themes?.light,
  ].filter(Boolean)

  themeTargets.forEach((target) => {
    Object.assign(target, themeValues)
  })

  if (typeof window !== 'undefined') {
    window.primaryColor = preset.primary
  }

  applyCssThemeVars(preset)
  return preset
}

export {
  THEME_PRESETS,
  DEFAULT_THEME_PRESET,
  DEFAULT_THEME_COLOR,
  applyThemePreset,
  getThemePreset,
  normalizeThemeColor,
}
